import React from "react";
import { Checkbox, Field, Label, Radio, RadioGroup, Slider } from "@fluentui/react-components";
import type { MarkerShape } from "../visualConfig";
import { type ChartStyleSectionProps, useSliderStyles } from "./shared";

const ScatterStyle: React.FC<ChartStyleSectionProps> = ({ chartStyle: cs, onStyleChange }) => {
  const styles = useSliderStyles();
  return (
    <>
      <div className={styles.sliderField}>
        <Label size="small">Marker Size</Label>
        <div className={styles.sliderRow}>
          <Slider
            min={2} max={20} step={1}
            value={cs.markerSize ?? 8}
            onChange={(_, data) => onStyleChange({ markerSize: data.value })}
            style={{ flex: 1 }}
          />
          <span className={styles.sliderValue}>{cs.markerSize ?? 8}px</span>
        </div>
      </div>
      <Field label="Marker Shape">
        <RadioGroup
          layout="horizontal"
          value={cs.markerShape ?? "circle"}
          onChange={(_, data) => onStyleChange({ markerShape: (data.value as MarkerShape) ?? "circle" })}
        >
          <Radio value="circle" label="Circle" />
          <Radio value="rect" label="Square" />
          <Radio value="triangle" label="Triangle" />
          <Radio value="diamond" label="Diamond" />
        </RadioGroup>
      </Field>
      <Checkbox
        label="Regression line"
        checked={cs.regressionLine ?? false}
        onChange={(_, data) => onStyleChange({ regressionLine: !!data.checked })}
      />
    </>
  );
};

export default ScatterStyle;